import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Denied = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const onBack = async () => { await logout(); navigate('/admin/login'); };
  return (
    <div className="min-h-screen marble-bg flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white border border-[#E8E2D5] p-10 text-center">
        <ShieldAlert size={32} className="mx-auto text-[#957340]" />
        <h1 className="h-display text-[28px] mt-5">Accès refusé</h1>
        <p className="text-[14px] text-[#3A3A3A] mt-3 leading-[1.7]">
          Votre compte Google n’est pas autorisé à accéder à l’interface d’administration.
        </p>
        <button onClick={onBack} className="btn-primary mt-8">Retour</button>
      </div>
    </div>
  );
};

export default Denied;
